import { useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';

import { useRealtimeFrame } from '../../shared/api/realtime';
import { notificationDigest, type TNotificationDigest } from './api';

export const DIGEST_KEY = ['notifications', 'digest'];

// The badge and the panel read one answer, so the number beside the bell is the lines inside it.
export const useDigestLiveUpdate = (
  options: { enabled?: boolean } = {},
): UseQueryResult<TNotificationDigest> => {
  const client = useQueryClient();

  useRealtimeFrame('counters', () => {
    void client.invalidateQueries({ queryKey: ['notifications'] });
  });

  return useQuery({
    queryKey: DIGEST_KEY,
    queryFn: notificationDigest,
    staleTime: 30_000,
    enabled: options.enabled ?? true,
  });
};
